export default "__VITE_ASSET__dfad7ca6__"